/**
 * Cash Reducer
 */

import { Actions } from "containers/Cash/store/Actions";
import { Reducer } from "redux";
import { getCashFormTranslations } from "root/shared/MultiLanguage";
import { IInputProps } from "root/store/CajitaStore";
import { ICashActionCreator } from "types/cash_action_creator";
import { ICashFormProps } from "types/cash_form_props";

const nameInputClasses: string[] = ["input"];

const initialState: ICashFormProps = {
  isCashAvailable: true,
  isValid: false,
  totalAmount: 0,
  token: "",
  nameInput: {
    container: "cash",
    value: "",
    classContainer: "inputContainer name-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^[ A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "nameInput",
      type: "text",
    },
  },
  lastNameInput: {
    container: "cash",
    value: "",
    classContainer: "inputContainer name-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^[ A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "lastNameInput",
      type: "text",
    },
  },
  identificationInput: {
    container: "cash",
    value: "",
    classContainer: "inputContainer id-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "identificationInput",
      type: "text",
    },
  },
  email: {
    container: "cash",
    value: "",
    classContainer: "inputContainer email-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: false,
      maxLength: 100,
      isEmail: {
        email: true,
      },
    },
    attributes: {
      id: "email",
      type: "text",
    },
  },
  description: {
    container: "cash",
    value: "",
    classContainer: "inputContainer description-input",
    valid: true,
    dirty: false,
    classes: nameInputClasses,
    inputPattern: /^[ A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: false,
      maxLength: 100,
    },
    attributes: {
      id: "description",
      type: "text",
    },
  },
  currency: "USD",
  translation: getCashFormTranslations(),
};

const CashReducer: Reducer<ICashFormProps> = (
  state: ICashFormProps = initialState,
  action: ICashActionCreator
): ICashFormProps => {
  let input: IInputProps;

  switch (action.type) {
    case Actions.UPDATE_CASH_INPUT:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: input,
      };
    case Actions.SET_CASH_INPUT_DIRTY:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: {
          ...state[input.attributes.id],
          dirty: true,
        },
      };
    case Actions.SWITCH_CASH_VALIDITY:
      return {
        ...state,
        isValid: !state.isValid,
      };
    case Actions.SET_CASH_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case Actions.DISABLE_CASH_FORM:
      return {
        ...state,
        isCashAvailable: false,
      };
    case Actions.ENABLE_CASH_FORM:
      return {
        ...state,
        isCashAvailable: true,
      };
    case Actions.UPDATE_DOCUMENT_TYPE_NUMBER:
      return {
        ...state,
        documentType: action.token,
      };
    default:
      return state;
  }
};

export { CashReducer };



// WEBPACK FOOTER //
// ./src/containers/Cash/store/Reducer.tsx